import { IconType } from "@src/appV2/redesign/components/Icon.types";
import { useWorkplaceMenuPrivilegesProviderContext } from "../Navigation/privilegesProviders/WorkplaceMenuPrivilegesProvider";
import { useHistory } from "react-router-dom";
import { getLocation } from "@src/appV2/redesign/utils/routes";
import { useModalState, type UseModalState } from "@src/lib/ui-react";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { useBrazeInitializedProviderContext } from "@src/appV2/redesign/AppLayout/Shared/BrazeContext";
import { useBrazeNotifications } from "@src/appV2/lib/Braze/useBrazeNotifications";
import { useIsHomeHealthWorkplace } from "@src/appV2/ExperimentalHomeHealth/lib/useIsHomeHealthWorkplace";
import { useHelpCenterEntry } from "@src/appV2/HelpCenter/useHelpCenterEntry";

export function useNavHeader(): {
  displayHelpButton: boolean;
  iconTypeHelpButton: IconType;
  onClickHelpButton: () => void;

  displayNotificationsButton: boolean;
  iconTypeNotificationsButton: IconType;
  unreadNotificationCount: number;
  notificationsCenterModalState: UseModalState;
  onClickNotificationsButton: () => void;

  displaySettingsButton: boolean;
  iconTypeSettingsButton: IconType;
  onClickSettingsButton: () => void;
} {
  const workplaceMenuPrivileges = useWorkplaceMenuPrivilegesProviderContext();
  const history = useHistory();

  const displayHelpButton = workplaceMenuPrivileges.helpCenter ?? false;
  const iconTypeHelpButton = "question-circle";
  const helpCenterEntry = useHelpCenterEntry();
  function onClickHelpButton() {
    if (helpCenterEntry.kind === "action") {
      helpCenterEntry.onClick();
      return;
    }
    history.push(helpCenterEntry.routeTo);
  }

  const { type: userType } = useSession();
  const isHomeHealthWorkplace = useIsHomeHealthWorkplace();
  const displayNotificationsButton = userType === "FACILITY" && !isHomeHealthWorkplace;

  const iconTypeNotificationsButton: IconType = "bell-solid";

  const { brazeInitialized } = useBrazeInitializedProviderContext();
  const { unreadCount: unreadNotificationCount } = useBrazeNotifications(brazeInitialized);

  const notificationsCenterModalState = useModalState();
  function onClickNotificationsButton() {
    notificationsCenterModalState.openModal();
  }

  const displaySettingsButton = workplaceMenuPrivileges.managementSection?.settings ?? false;
  const iconTypeSettingsButton = "cogwheel";
  function onClickSettingsButton() {
    history.push(getLocation("settings"));
  }

  return {
    displayHelpButton,
    iconTypeHelpButton,
    onClickHelpButton,

    displayNotificationsButton,
    iconTypeNotificationsButton,
    unreadNotificationCount,
    notificationsCenterModalState,
    onClickNotificationsButton,

    displaySettingsButton,
    iconTypeSettingsButton,
    onClickSettingsButton,
  };
}
